export default {
  'GET_CUSTOM_FORM_DATA_FOR_ALIAS': (state) => (alias) => {
    return alias && state.customForm[alias] || state.customForm;
  },
};
